import type { SxProps } from '@mui/material';

export {
  getReconFlagsFiltersSearchFieldSx as getFlagGlossaryFiltersSearchFieldSx,
  reconFlagsFiltersSeverityPillsRowSx as flagGlossaryFiltersSeverityPillsRowSx,
  reconFlagsFiltersToolbarSx as flagGlossaryFiltersToolbarSx,
} from '@ovComponents/4-module/reconFlags/filters/reconFlagsFilters.styles';

export const flagGlossaryFiltersMainRowSx: SxProps = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  gap: 1.5,
  flex: 1,
  minWidth: 0,
};
